import "../libs/spinner";
import {requestStopNotifications} from "../libs/apiv2-requests";
const member = {};
export default member;

member.stopNotifications = async function(id, type) {
    try {
        spinner.show();
        if (requestStopNotifications(id, type)) {
            await window.openAlert(window.unsubscribe_success_msg || 'You have been unsubscribed', 'success');
        } else {
            await window.openAlert(getCommonError(), 'error');
        }
    } catch (e) {
        spinner.remove();
        await window.openAlert(getCommonError(), 'error');
    }
    spinner.remove();
};
